import { Banner, bannerVariants } from '../Banner';
import { useReportSubscriptionBanner } from '../../contexts/SubscriptionBanner.context';

export const SubscriptionWarningNonAdmin = ({ subscription = {} }) => {
  let showWarning = subscription?.isTrialActive;
  if (subscription?.subscriptionEndDate?.toDate) {
    //check if subscription will end in 14 days
    showWarning =
      subscription?.subscriptionEndDate?.toDate() - new Date() <
      14 * 24 * 60 * 60 * 1000;
  }

  useReportSubscriptionBanner(!!showWarning);

  if (!showWarning) return null;

  return (
    <Banner variant={bannerVariants.warning}>
      Your Plan is about to Expire. Please contact your Administrator.
    </Banner>
  );
};
